import { JUPITER_LINK } from "./constants"

export const Routes = {
    WHITEPAPER: {
        text: "Whitepaper",
        href: "/whitepaper",
        isNested: true,
    },
    HOME: {
        text: "Home",
        href: "/",
    },
    ROADMAP: {
        text: "Roadmap",
        href: "/roadmap",
    },
    BUY: {
        text: "Buy",
        href: JUPITER_LINK,
        isExternal: true,
    },
    COMMUNITY: {
        text: "Community",
        href: "/community",
    },
    TOKENOMICS: {
        text: "Tokenomics",
        href: "/tokenomics",
    },
    TEAM: {
        text: "Team",
        href: "/team",
    },
} as const satisfies Record<
    string,
    {
        text: string
        href: string
        isExternal?: boolean
        isNested?: boolean
    }
>
